"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _banner = require("@/api/banner/banner");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      info: {},
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "标题",
        prop: "name",
        isShow: true,
        width: "200"
      }, {
        name: "图片",
        prop: "imageUrl",
        isShow: true,
        width: "200",
        isImg: true,
        linkColumn: "imageUrl"
      }, {
        name: "链接",
        prop: "linkUrl",
        isShow: true,
        width: "400",
        isLink: true,
        linkColumn: "linkUrl"
      }],
      funBtns: [{
        size: "small",
        click: "add",
        name: "新增",
        type: "primary"
      }, {
        size: "small",
        click: "deleteById",
        name: "批量删除",
        type: "danger"
      }],
      options: [{
        name: "编辑",
        class: "edit",
        option: "edit",
        span: 3
        // isFuntion: true,
        // optionFun: "noEditBtn"
      }, {
        name: "删除",
        class: "delet",
        option: "deleteById",
        span: 3
        // isFuntion: true,
        // optionFun: "noEditBtn"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {},
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      swiperInfo: {}
    };
  },
  methods: {
    noEditBtn: function noEditBtn() {},
    // 获取轮播图列表
    getSwipre: function getSwipre() {
      var _this2 = this;
      (0, _banner.selectPageList)({
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        schoolId: this.info.schoolId
      }).then(function (res) {
        console.log(res);
        var data = res.data;
        _this2.listData = data.list;
        _this2.totalData = data.total;
      });
    },
    // 新增
    add: function add() {
      this.$router.push("/webSet/swiperSchool/swiperAdd");
    },
    // 编辑
    edit: function edit(e) {
      this.$router.push({
        path: "/webSet/swiperSchool/swiperEdit",
        query: e
      });
    },
    //删除
    deleteById: function deleteById(row) {
      var _this3 = this;
      if (this.listData.length === 1) {
        this.$message.error("将删除最后一张照片");
      }
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _banner.deleteBanner)(id).then(function () {
          _this3.getSwipre();
          _this3.$message.success("操作成功。");
        });
      }).catch(function () {
        _this3.$message.info("取消删除。");
      });
    },
    listBureau: function listBureau() {},
    dels: function dels() {},
    save: function save() {},
    handleSelectionChange: function handleSelectionChange(e) {
      var _this4 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this4.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getSwipre();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getSwipre();
    },
    // 拖拽
    rowDrop: function rowDrop() {
      var tbody = document.querySelector(".el-table__body-wrapper tbody");
      var _this = this;
      _sortablejs.default.create(tbody, {
        draggable: ".el-table__row",
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
            oldIndex = _ref.oldIndex;
          var x = _this.listData[oldIndex];
          _this.listData.splice(oldIndex, 1);
          _this.listData.splice(newIndex, 0, x);
          _this.listData.forEach(function (item, index, arr) {
            arr[index].sort = index;
            console.log(arr[index].sort, arr[index], ' arr[index].sort');
            _this.swiperInfo = arr[index];
            _this.submitSort(arr[index].sort);
          });
          _this.getSwipre();
          // console.log(_this.listData,'_this.listData');
          // sortBanner(_this.listData).then(res => {
          //   _this.getSwipre();
          // });
        }
      });
    },
    submitSort: function submitSort(val) {
      (0, _banner.updateInfoBanner)({
        imageUrl: this.swiperInfo.imageUrl,
        linkUrl: this.swiperInfo.linkUrl,
        name: this.swiperInfo.name,
        businessId: this.info.businessId,
        isDelete: 0,
        schoolId: this.swiperInfo.schoolId,
        sort: val,
        id: this.swiperInfo.id
      });
    }
  },
  created: function created() {
    this.info = JSON.parse(sessionStorage.getItem("info"));
    this.getSwipre();
  },
  components: {
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};